import i18n from "./index";

const loc = () => i18n.language;
const d = (v) => (v instanceof Date ? v : new Date(v));

export const fmtDate = (v, o = { dateStyle: "long" }) => (v ? new Intl.DateTimeFormat(loc(), o).format(d(v)) : "");
export const fmtShortDate = (v) => fmtDate(v, { dateStyle: "medium" });
export const fmtDateTime = (v) => fmtDate(v, { dateStyle: "medium", timeStyle: "short" });
export const fmtNumber = (n, o) => new Intl.NumberFormat(loc(), o).format(n ?? 0);
export const fmtMoney = (n, currency = "EUR", o = {}) =>
  new Intl.NumberFormat(loc(), { style: "currency", currency: currency.toUpperCase(), maximumFractionDigits: n % 1 ? 2 : 0, ...o }).format(n ?? 0);
export const fmtPercent = (ratio) => new Intl.NumberFormat(loc(), { style: "percent", maximumFractionDigits: 0 }).format(ratio ?? 0);

export function fmtRelative(v) {
  const s = (d(v).getTime() - Date.now()) / 1000;
  const rtf = new Intl.RelativeTimeFormat(loc(), { numeric: "auto" });
  for (const [u, n] of [["year", 31536000], ["month", 2592000], ["day", 86400], ["hour", 3600], ["minute", 60]]) if (Math.abs(s) >= n) return rtf.format(Math.round(s / n), u);
  return rtf.format(Math.round(s), "second");
}
